import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_cgzjcth7hb: FaireBrandEntity = {
  token: "b_cgzjcth7hb",
  type: "brand",
  name: "Four Barrel Coffee",
  avatarUrl:
    "https://cdn.faire.com/fastly/8dfbf8486612d8f1abfe356e702e2965552920e370551ea9e9bee082bc5f4afc.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a9db0ddba41d30f59869e008c70b3ccc20af3d6c2873c5221b5a011242d191c9.png",
  logoUrl:
    "https://cdn.faire.com/fastly/8dfbf8486612d8f1abfe356e702e2965552920e370551ea9e9bee082bc5f4afc.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a9db0ddba41d30f59869e008c70b3ccc20af3d6c2873c5221b5a011242d191c9.png",
  location: "San Francisco, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 2,
  isInsider: true,
  description:
    "Where does great coffee come from? It comes from third-generation farmers and mill-workers in Latin America, Indonesia, and East Africa. And that’s where we go to find it, forging relationships that ensure quality of life for our producers, and high-quality coffee for our tiny roastery in San Francisco.\n\nYou can taste the fruits of these relationships in every bag of sweet, clean, and beautifully complex Four Barrel Coffee. Please join us in building great relationships in the service of great coffee.\n\n- The Four Barrel Coffee family",
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:03:42.297Z",
    importedBy: "entity-db-cli",
  },
};
